import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConsolidateUser, ConsolidateUserInput, DeleteUserInput, GraphDotnetService, graphql, Maybe, User } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class UserService {
    protected readonly graphDotnetService = inject(GraphDotnetService);


    getUser(userId: string): Observable<Maybe<User> | undefined> {
        return this.graphDotnetService.query(graphql`
                query getUser($userId: UUID!) {
                    user(id: $userId) {
                        id
                        storeUserId
                        dateCreatedUtc
                        lastTokenGenerationDateUtc
                        isGuest
                        aliases {
                            id
                            storeUserId
                        }
                        consolidatedUser {
                            id
                            storeUserId
                        }
                        consolidatedUserId
                        consolidationDateUtc
                        isDeleted
                        storeId
                        store {
                            id
                            subscriptionId
                        }
                        projects {
                            id
                            isDeleted
                            dateCreatedUtc
                            lastAccessDateUtc
                            currentVersion {
                                id
                                lastModifiedUtc
                                thumbnailUrl
                            }
                            product {
                                id
                            }
                            theme {
                                id
                            }
                        }
                    }
                }
            `, { userId }
        ).pipe(map(x => x.user));
    }

    deleteUser(input: DeleteUserInput) {
        return this.graphDotnetService.mutate(graphql`mutation deleteUser($input: DeleteUserInput!){
                deleteUser(input: $input)
            }`, { input }
        ).pipe(map(x => x.deleteUser));
    }

    consolidateUser(input: ConsolidateUserInput): Observable<ConsolidateUser> {
        return this.graphDotnetService.mutate(graphql`mutation consolidateUser($input: ConsolidateUserInput!){
                consolidateUser(input: $input) {
                    identifiedHubUserId
                }
            }`, { input }
        ).pipe(map(x => x.consolidateUser));
    }
}
